import { render, staticRenderFns } from "./OzPopoverTip.vue?vue&type=template&id=19b3b838&"
import script from "./OzPopoverTip.vue?vue&type=script&lang=ts&"
export * from "./OzPopoverTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports